import controller from './quotations.controller';
import template from './quotations.view.html';

let QuotationsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default QuotationsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/quotations/quotations.component.js
 **/